import { SolutionTag, SourcingLineItemDTO } from '@luminovo/api-contracts';

export function hasSourcingLineItemManualCost({
    solution_summary,
}: Pick<SourcingLineItemDTO, 'solution_summary'>): boolean {
    return solution_summary.solution_tags.some(({ tag }) => tag === SolutionTag.ManualOneTimeCost);
}
